module.exports = {
  modelsData: () => {
    return [
      {
        'F-150 RAPTOR':{
          model: './models/F150_RAPTOR/scene.glb',
          colors: [
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'Negro Ágata',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/NegroAgata.webp'),
              settings: {
                color: 0x000000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'BLANCO AVALANCHE',
							NameAlt: 'Blanco Avalanche',
							Hexa: '#D8DDE9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/BlancoOxford.webp'),
              settings: {
                color: 0xD8DDE9,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NARANJA METÁLICO',
							NameAlt: 'Naranja Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/NaranjaMetalico.webp'),
              settings: {
                color: 0xD50F01,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS AZULADO',
							NameAlt: 'Gris Azulado',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/GrisAzulado.png'),
              settings: {
                color: 0x637383,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.5,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.5
              }
						}
					],
          accesories: [
            {
              model: './models/F150_RAPTOR/accessories/ADM_BarraAntivuelcoNegraMate.glb',
              name: 'ADM_BarraAntivuelcoNegraMate',
              carpaint: false,
              showroom: 'Barra Antivuelco Negro Mate',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/F150_RAPTOR/thumbs/th_BarraAntivuelcoNegraMate.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_SpoilerCabina'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CajaAlmacenamientoIzquierdo.glb',
              name: 'ADM_CajaAlmacenamientoIzquierdo',
              carpaint: false,
              showroom: 'Caja de Almacenamiento Izquierdo',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CajadeAlmacenamientoLadoIzquierdo.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlatonSuave.glb',
              name: 'ADM_CubiertaPlatonSuave',
              carpaint: false,
              showroom: 'Cubierta de Platón Suave',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlatonSuave5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_MallaCarga','ADM_CajaAlmacenamientoIzquierdo'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlegableCubreplaton.glb',
              name: 'ADM_CubiertaPlegableCubreplaton',
              carpaint: false,
              showroom: 'Cubierta Plegable Cubreplatón 5.5',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlegableCubreplaton5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlegablePlaton.glb',
              name: 'ADM_CubiertaPlegablePlaton',
              carpaint: false,
              showroom: 'Cubierta Plegable de Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlegablePlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_DivisorPlaton.glb',
              name: 'ADM_DivisorPlaton',
              carpaint: false,
              showroom: 'Divisor Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_DivisorPlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_MallaCarga'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_MallaCarga.glb',
              name: 'ADM_MallaCarga',
              carpaint: false,
              showroom: 'Malla de Carga',
              section: 'Organizadores de Carga',
              Image: './models/F150_RAPTOR/thumbs/th_MalladeCarga.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_MolduraPuertas.glb',
              name: 'ADM_MolduraPuertas',
              carpaint: false,
              showroom: 'Moldura de Puertas',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_RAPTOR/thumbs/th_MolduradePuertas.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SalpicaderasLlantasTraseras.glb',
              name: 'ADM_SalpicaderasLlantasTraseras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas traseras',
              section: 'Salpicaderas',
              Image: './models/F150_RAPTOR/thumbs/th_SalpicaderasLlantasTraseras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              carpaint: false,
              showroom: 'Spoiler de Cabina',
              section: 'Spoilers',
              Image: './models/F150_RAPTOR/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraAntivuelcoNegraMate'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              carpaint: false,
              showroom: 'Spoiler de Compuerta Trasera',
              section: 'Spoilers',
              Image: './models/F150_RAPTOR/thumbs/th_SpoilerdeCompuertaTrasera.webp',
              hide: [],
              compatible: [

              ]   
            },
          ]
        },
        'MUSTANG GT PREMIUM': {
          model: './models/MUSTANG_GT_PREMIUM/scene.glb',
          colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'Azul Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangGTPremium/AzulGalactico.webp'),
              settings: {
                color: 0x004D99,
                emissive: 0x001E3D,
                emissiveIntesity: 1.40,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
						{
							Name: 'ROJO RALLY',
							NameAlt: 'Rojo Rally',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/MustangGTPremium/RojoRally.webp'),
              settings: {
                color: 0xE60000,
                emissive: 0x000000,
                emissiveIntesity: 1.0,
                metalness: 1,
                roughness: 0.6,
                clearcoat: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'Gris Carbón',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
              settings: {
                color: 0x5C5C5C,
                emissive: 0x000000,
                emissiveIntesity: 1.0,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						}
					],
          accesories: [
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/BDM_DifusorBalanceTrasero.glb',
              name: 'BDM_DifusorBalanceTrasero',
              carpaint: true,
              showroom: 'Difusor de Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/BDM_DivisorParachoquesDelantero.glb',
              name: 'BDM_DivisorParachoquesDelantero',
              carpaint: true,
              showroom: 'Divisor Parachoques Delantero',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DivisorParachoquesDelantero'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/BDM_JuegoPanelesLaterales.glb',
              name: 'BDM_JuegoPanelesLaterales',
              carpaint: true,
              showroom: 'Juego De Paneles Laterales',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/BDM_JuegoVentilacionCapoSatinBlack.glb',
              name: 'BDM_JuegoVentilacionCapoSatinBlack',
              carpaint: true,
              showroom: 'Juego De ventilación Capó Satín Black',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_JuegoVentilacionCapoSatinBlack'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/BDM_SpoilerBaulMustangTechoRigido.glb',
              name: 'BDM_SpoilerBaulMustangTechoRigido',
              carpaint: true,
              showroom: 'Spoiler Baúl Mustang Techo Rígido',
              section: 'Spoilers',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_SpoilerBaulMustangTechoRigido','BDM_SpoilerTraseroCoupe','ADM_SpoilerTraseroCoupe'],
              compatible: [

              ]   
            },

            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_DifusorBalanceTrasero.glb',
              name: 'ADM_DifusorBalanceTrasero',
              carpaint: true,
              showroom: 'Difusor De Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_DifusorDeBalanceTrasero.webp',
              hide: ['BDM_DifusorBalanceTrasero'],
              enableOnDisable: ['BDM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_DivisorParachoquesDelantero.glb',
              name: 'ADM_DivisorParachoquesDelantero',
              carpaint: true,
              showroom: 'Divisor Parachoques Delantero',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_DivisorParachoquesDelantero.webp',
              hide: ['BDM_DivisorParachoquesDelantero'],
              enableOnDisable: ['BDM_DivisorParachoquesDelantero'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_JuegoCortinasAireSatinBlack.glb',
              name: 'ADM_JuegoCortinasAireSatinBlack',
              carpaint: true,
              showroom: 'Juego De Cortinas De Aire Satín Black',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_JuegoDeCortinasDeAireSatinBlack.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_JuegoFaldonesLaterales.glb',
              name: 'ADM_JuegoFaldonesLaterales',
              carpaint: true,
              showroom: 'Juego De Faldones Laterales',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_JuegoDeFaldonesLaterales.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_JuegoPanelesLaterales.glb',
              name: 'ADM_JuegoPanelesLaterales',
              carpaint: true,
              showroom: 'Juego De Paneles Laterales',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_JuegoDePanelesLaterales.webp',
              hide: [],
              enableOnDisable: ['BDM_JuegoPanelesLaterales'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_JuegoPanelesVentana.glb',
              name: 'ADM_JuegoPanelesVentana',
              carpaint: true,
              showroom: 'Juego De Paneles Para Ventana',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_JuegoDePanelesParaVentana.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_JuegoVentilacionCapoSatinBlack.glb',
              name: 'ADM_JuegoVentilacionCapoSatinBlack',
              carpaint: true,
              showroom: 'Juego De ventilación Capó Satín Black',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_JuegoDeVentilacionCapotSatinBlack.webp',
              hide: ['BDM_JuegoVentilacionCapoSatinBlack'],
              enableOnDisable: ['BDM_JuegoVentilacionCapoSatinBlack'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_SpoilerBaulMustangTechoRigido.glb',
              name: 'ADM_SpoilerBaulMustangTechoRigido',
              carpaint: true,
              showroom: 'Spoiler Baúl Mustang Techo Rígido',
              section: 'Spoilers',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_SpoilerBaúlMustangConvertible.webp',
              hide: ['BDM_SpoilerBaulMustangTechoRigido','BDM_SpoilerTraseroCoupe','ADM_SpoilerTraseroCoupe'],
              enableOnDisable: ['BDM_SpoilerBaulMustangTechoRigido'],
              compatible: [

              ]   
            },
            {
              model: './models/MUSTANG_GT_PREMIUM/accessories/ADM_SpoilerTraseroCoupe.glb',
              name: 'ADM_SpoilerTraseroCoupe',
              carpaint: true,
              showroom: 'Spoiler Trasero Coupe',
              section: 'Spoilers',
              Image: './models/MUSTANG_GT_PREMIUM/thumbs/th_SpoilerTraseroCoupe.webp',
              hide: ['ADM_SpoilerBaulMustangTechoRigido','BDM_SpoilerBaulMustangTechoRigido','BDM_SpoilerTraseroCoupe'],
              enableOnDisable: ['BDM_SpoilerBaulMustangTechoRigido'],
              compatible: [

              ]   
            },
            
          ]
        },
        /*'MUSTANG MACH 1': {
          model: './models/MUSTANG_MACH1/scene.glb',
          colors: [
						{
							Name: 'BLANCO OXFORD',
							NameAlt: 'BLANCO OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangMach1/BlancoOxford.webp'),
              settings: {
                color: 0xF0F0F0,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.8
              },
              stickerColor: {
                color: 0xDB0000,
                metalness: 0,
                roughness: 1
              }
						},
            {
							Name: 'GRIS ACERO',
							NameAlt: 'GRIS ACERO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangMach1/GrisAcero.webp'),
              settings: {
                color: 0x828786,
                emissive: 0x081711,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.8
              },
              stickerColor: {
                color: 0xC8811C,
                metalness: 0,
                roughness: 1
              }
						},
            {
							Name: 'NARANJA METÁLICO',
							NameAlt: 'NARANJA METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangMach1/NaranjaMetalico.webp'),
              settings: {
                color: 0xE66100,
                emissive: 0x2C0202,
                emissiveIntesity: 2,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.8
              },
              stickerColor: {
                color: 0xFFFFFF,
                metalness: 0,
                roughness: 1
              }
						},
            {
							Name: 'NEGRO PROFUNDO',
							NameAlt: 'NEGRO PROFUNDO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangMach1/NegroProfundo.webp'),
              settings: {
                color: 0x1C1C1C,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.8
              },
              stickerColor: {
                color: 0xDB0000,
                metalness: 0,
                roughness: 1
              }
						}
					],
          accesories: [
            {
              model: './models/MUSTANG_MACH1/accessories/BDM_StickerColorVariable.glb',
              name: 'BDM_StickerColorVariable',
              carpaint: true,
              showroom: '',
              section: '',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: [],
              compatible: [

              ]   
            }
            
          ]
        },*/
        /*'EDGE ST': {
          model: './models/EDGE_ST/scene.glb',
          colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
              settings: {
                color: 0xAB0B23,
                emissive: 0xCB1A70,
                emissiveIntesity: 0.02,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x7D7D7D,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'AZUL PERFORMANCE',
							NameAlt: 'AZUL PERFORMANCE',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/AzulPerformance.webp'),
              settings: {
                color: 0x005FA3,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xF5F5F5,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xBABAC5,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x121212,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 1,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.4
              }
						},
            
					],
          accesories: [            
          ]
        },*/
        /*'EXPLORER ST': {
          model: './models/EXPLORER_ST/scene.glb',
          colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
              settings: {
                color: 0xB4041E,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x36373A,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'AZUL OXFORD',
							NameAlt: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerST/AzulOxford.webp'),
              settings: {
                color: 0x153960,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xEDEDED,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0x929695,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x0F0F0F,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            
					],
          accesories: [            
          ]
        },*/
        /*'EXPEDITION LIMITED': {
          model: './models/EXPEDITION/scene.glb',
          colors: [
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExpeditionLimited/GrisMagnetico.webp'),
              settings: {
                color: 0x767674,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xBEC1C6,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x242424,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            
					],
          accesories: [            
          ]
        },*/
        /*'RANGER FX4': {
          model: './models/RANGER_FX4/scene.glb',
          colors: [
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/BlancoArtico.webp'),
              settings: {
                color: 0xEBEBEB,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.35,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/GrisMagnetico.webp'),
              settings: {
                color: 0x888686,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.35,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'NEGRO PERLADO',
							NameAlt: 'NEGRO PERLADO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/NegroPerlado.webp'),
              settings: {
                color: 0x1D1D1D,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.35,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/PlataMetalico.webp'),
              settings: {
                color: 0x6C6B6A,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.35,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/RojoRubi.webp'),
              settings: {
                color: 0x850000,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.35,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.35
              }
						},
					],
          accesories: [            
          ]
        },*/
        'ESCAPE ECOBOOST': {
          model: './models/ESCAPE_ECOBOOST/scene.glb',
          colors: [
            {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/RojoLucido.webp'),
              settings: {
                color: 0xBD0019,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/AzulMetalico.webp'),
              settings: {
                color: 0x52576B,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'ARENA PERLADA',
							NameAlt: 'ARENA PERLADA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/ArenaPerlada.webp'),
              settings: {
                color: 0x7A6F66,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x0A0A0A,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/GrisMagnetico.webp'),
              settings: {
                color: 0x4E4D4B,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'PLATA SOLAR',
							NameAlt: 'PLATA SOLAR',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/Plata Solar.webp'),
              settings: {
                color: 0x656667,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.35,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/BlancoArtico.webp'),
              settings: {
                color: 0xFFFFFF,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.3,
                reflectivity: 0.8,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},

            
					],
          accesories: [
            {
              model: './models/ESCAPE_ECOBOOST/accessories/BDM_JuegoMoldurasPuerta.glb',
              name: 'BDM_JuegoMoldurasPuerta',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['BDM_PlacaAntideslizanteTrasera'],
              enableOnDisable: ['BDM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/BDM_PlacaAntideslizanteTrasera.glb',
              name: 'BDM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de Techo',
              carpaint: false,
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_BarrasdeTecho.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos Negros',
              carpaint: false,
              section: 'Estribos',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_EstribosNegros.webp',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos Negros con Bisel Cromado',
              carpaint: false,
              section: 'Estribos',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_EstribosNegrosconBiselCromado.webp',
              hide: ['ADM_EstribosNegros'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_JuegoMoldurasArcoRueda.glb',
              name: 'ADM_JuegoMoldurasArcoRueda',
              showroom: 'Juego de Molduras de Arco de Rueda',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_JuegoDe MoldurasdeArco deRueda.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_JuegoCortinasAire.glb',
              name: 'ADM_JuegoCortinasAire',
              showroom: 'Juego de Cortinas de Aire',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_JuegoDeCortinasDeAire.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_JuegoMoldurasPuerta.glb',
              name: 'ADM_JuegoMoldurasPuerta',
              showroom: 'Juego de Molduras de Puerta',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_JuegoDeMoldurasDePuerta.webp',
              hide: ['BDM_JuegoMoldurasPuerta'],
              enableOnDisable: ['BDM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_PlacaAntideslizanteDelantera.glb',
              name: 'ADM_PlacaAntideslizanteDelantera',
              showroom: 'Placa Antideslizante Delantera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_PlacaAntideslizanteDelantera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_ECOBOOST/accessories/ADM_PlacaAntideslizanteTrasera.glb',
              name: 'ADM_PlacaAntideslizanteTrasera',
              showroom: 'Placa Antideslizante Trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_ECOBOOST/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['BDM_PlacaAntideslizanteTrasera'],
              enableOnDisable: ['BDM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
          ]
        },
        'ESCAPE SE 4X2 FHEV': {
          model: './models/ESCAPE_SE/scene.glb',
          colors: [
            {
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/AzulMetalico.webp'),
              settings: {
                color: 0x007BC7,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.33,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.04,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/RojoLucido.webp'),
              settings: {
                color: 0xB30002,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
              settings: {
                color: 0x545454,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/PlataPuro.webp'),
              settings: {
                color: 0x9E9E9E,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.38,
                clearcoat: 0.67,
                reflectivity: 0.8,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/BlancoPlatino.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x030303,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						}
					],
          accesories: [
            {
              model: './models/ESCAPE_SE/accessories/BDM_JuegoMoldurasPuerta.glb',
              name: 'BDM_JuegoMoldurasPuerta',
              carpaint: true,
              showroom: 'Juego de molduras de puerta base',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/BDM_PlacaAntideslizanteTrasera.glb',
              name: 'BDM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera base',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de techo',
              section: 'Barras, Rieles, Parrillas',
              Image: './models/ESCAPE_SEL/thumbs/th_BarrasdeTecho.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos negros',
              section: 'Estribos',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegros.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos negros con bisel cromado',
              section: 'Estribos',
              hide: ['ADM_EstribosNegros'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegrosconBiselCromado.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoCortinasAire.glb',
              name: 'ADM_JuegoCortinasAire',
              showroom: 'Juego de cortinas de aire',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeCortinasDeAire.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoMoldurasArcoRueda.glb',
              name: 'ADM_JuegoMoldurasArcoRueda',
              showroom: 'Juego de molduras de arco de rueda',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasdeArcodeRueda.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoMoldurasPuerta.glb',
              name: 'ADM_JuegoMoldurasPuerta',
              showroom: 'Juego de molduras de puerta',
              section: 'Molduras, Paneles, Apliques',
              carpaint: true,
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasDePuerta.webp',
              hide: ['BDM_JuegoMoldurasPuerta'],
              enableOnDisable: ['BDM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_PlacaAntideslizanteDelantera.glb',
              name: 'ADM_PlacaAntideslizanteDelantera',
              showroom: 'Placa antideslizante delantera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteDelantera.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_PlacaAntideslizanteTrasera.glb',
              name: 'ADM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['BDM_PlacaAntideslizanteTrasera'],
              enableOnDisable: ['BDM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
          ]
        },
        'ESCAPE SEL 4X2 FHEV': {
          model: './models/ESCAPE_SEL/scene.glb',
          colors: [
            {
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/AzulMetalico.webp'),
              settings: {
                color: 0x007BC7,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.33,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.04,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/RojoLucido.webp'),
              settings: {
                color: 0xB30002,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
              settings: {
                color: 0x545454,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/PlataPuro.webp'),
              settings: {
                color: 0x9E9E9E,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.38,
                clearcoat: 0.67,
                reflectivity: 0.8,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/BlancoPlatino.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x030303,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						}
					],
          accesories: [
            {
              model: './models/ESCAPE_SEL/accessories/BDM_JuegoMoldurasPuerta.glb',
              name: 'BDM_JuegoMoldurasPuerta',
              carpaint: true,
              showroom: 'Juego de molduras de puerta base',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/BDM_PlacaAntideslizanteTrasera.glb',
              name: 'BDM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera base',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de techo',
              section: 'Barras, Rieles, Parrillas',
              Image: './models/ESCAPE_SEL/thumbs/th_BarrasdeTecho.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos negros',
              section: 'Estribos',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegros.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos negros con bisel cromado',
              section: 'Estribos',
              hide: ['ADM_EstribosNegros'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegrosconBiselCromado.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_JuegoCortinasAire.glb',
              name: 'ADM_JuegoCortinasAire',
              showroom: 'Juego de cortinas de aire',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeCortinasDeAire.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_JuegoMoldurasArcoRueda.glb',
              name: 'ADM_JuegoMoldurasArcoRueda',
              showroom: 'Juego de molduras de arco de rueda',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasdeArcodeRueda.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_JuegoMoldurasPuerta.glb',
              name: 'ADM_JuegoMoldurasPuerta',
              showroom: 'Juego de molduras de puerta',
              section: 'Molduras, Paneles, Apliques',
              carpaint: true,
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasDePuerta.webp',
              hide: ['BDM_JuegoMoldurasPuerta'],
              enableOnDisable: ['BDM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_PlacaAntideslizanteDelantera.glb',
              name: 'ADM_PlacaAntideslizanteDelantera',
              showroom: 'Placa antideslizante delantera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteDelantera.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SEL/accessories/ADM_PlacaAntideslizanteTrasera.glb',
              name: 'ADM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['BDM_PlacaAntideslizanteTrasera'],
              enableOnDisable: ['BDM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
          ]
        },
        'RANGER XL': {
          model: './models/RANGER_XL/scene.glb',
          colors: [
            /* {
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'Azul Relámpago',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/AzulRelampago.webp'),
              settings: {
                color: 0x0065D1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						}, */
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'Blanco Ártico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/BlancoArtico.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            /* {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'Gris Magnético',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/GrisMagnetico.webp'),
              settings: {
                color: 0x808080,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 0.75
              }
						}, */
            /* {
							Name: 'NEGRO PERLADO',
							NameAlt: 'Negro Perlado',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/NegroPerlado.webp'),
              settings: {
                color: 0x000000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						}, */
            {
							Name: 'PLATA METÁLICO',
							NameAlt: 'Plata Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/PlataMetalico.webp'),
              settings: {
                color: 0xBBBCC3,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            /* {
							Name: 'ROJO RUBI',
							NameAlt: 'Rojo Rubí',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/RojoRubi.webp'),
              settings: {
                color: 0xB40E16,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						}, */
					],
          accesories: [
            {
              model: './models/RANGER_XL/accessories/BDM_BedlinerPerfilSuperior.glb',
              name: 'BDM_BedlinerPerfilSuperior',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/BDM_KitExtensionesRuedaFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedaFenderFlares',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/BDM_ProtectorBumperLucesDRL.glb',
              name: 'BDM_ProtectorBumperLucesDRL',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },

            {
              model: './models/RANGER_XL/accessories/ADM_BarraK1Cromada.glb',
              name: 'ADM_BarraK1Cromada',
              showroom: 'Barra K1 Cromada',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_BarraK1Cromada.webp',
              hide: ['ADM_BarraK1Negra','ADM_CapotaLonaDCAllBlack', 'ADM_SpoilerCabina'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_BarraK1Negra.glb',
              name: 'ADM_BarraK1Negra',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_BarraK1Negra.webp',
              hide: ['ADM_BarraK1Cromada','ADM_CapotaLonaDCAllBlack', 'ADM_SpoilerCabina'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_BedlinerPerfilSuperior.glb',
              name: 'ADM_BedlinerPerfilSuperior',
              showroom: 'Bedliner con Perfil Superior',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_BedlinerconPerfilSuperior.webp',
              hide: ['ADM_PerfilesSuperioresLaterales','BDM_BedlinerPerfilSuperior','ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_CapotaLonaBarraFibra.glb',
              name: 'ADM_CapotaLonaBarraFibra',
              showroom: 'Capota Lona Barra Fibra',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_CapotaLonaBarraFibra.webp',
              hide: ['ADM_BarraK1Negra','ADM_BarraK1Cromada','ADM_CapotaLonaDCAllBlack'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_CapotaLonaDCAllBlack.glb',
              name: 'ADM_CapotaLonaDCAllBlack',
              showroom: 'Capota Lona DC All Black',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_CapotaLonaDCAllBlack.webp',
              hide: ['ADM_BarraK1Negra','ADM_BarraK1Cromada','ADM_CapotaLonaBarraFibra'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_EstribosTubularesCromados.glb',
              name: 'ADM_EstribosTubularesCromados',
              showroom: 'Estribos Tubulares Cromados',
              carpaint: false,
              section: 'Estribos',
              Image: './models/RANGER_XL/thumbs/th_EstribosTubularesCromados.webp',
              hide: ['ADM_EstribosTubularesNegros'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_EstribosTubularesNegros.glb',
              name: 'ADM_EstribosTubularesNegros',
              showroom: 'Estribos Tubulares Negros',
              carpaint: false,
              section: 'Estribos',
              Image: './models/RANGER_XL/thumbs/th_EstribosTubularesNegros.webp',
              hide: ['ADM_EstribosTubularesCromados'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              showroom: 'Kit Extensiones de Rueda Fender Flares',
              carpaint: false,
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/RANGER_XL/thumbs/th_KitExtensionesdeRuedaFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedaFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedaFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_MolduraCompuertaTrasera.glb',
              name: 'ADM_MolduraCompuertaTrasera',
              showroom: 'Moldura Compuerta Trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_MolduraCompuertaTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_MoldurasCapot.glb',
              name: 'ADM_MoldurasCapot',
              showroom: 'Molduras Capot',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_MoldurasCapot.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_PanelesPuerta.glb',
              name: 'ADM_PanelesPuerta',
              showroom: 'Paneles Puerta',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_PanelesPuerta.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_PerfilesSuperioresLaterales.glb',
              name: 'ADM_PerfilesSuperioresLaterales',
              showroom: 'Perfiles Superiores Laterales',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_PerfilesSuperioresLaterales.webp',
              hide: ['ADM_BedlinerPerfilSuperior','BDM_BedlinerPerfilSuperior'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_PerfilSuperiorCompuerta.glb',
              name: 'ADM_PerfilSuperiorCompuerta',
              showroom: 'Perfil Superior Compuerta',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XL/thumbs/th_PerfilSuperiorCompuerta.webp',
              hide: ['ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_ProtectorBumperLucesDRL.glb',
              name: 'ADM_ProtectorBumperLucesDRL',
              showroom: 'Protector Bumper Luces DRL',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XL/thumbs/th_ProtectordeBumperconLucesDRL.webp',
              hide: ['BDM_ProtectorBumperLucesDRL'],
              enableOnDisable: ['BDM_ProtectorBumperLucesDRL'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              showroom: 'Spoiler de Cabina',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XL/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraK1Cromada','ADM_BarraK1Cromada'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XL/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              showroom: 'Spoiler Compuerta Trasera',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XL/thumbs/th_SpoilerCompuertaTrasera.webp',
              hide: ['ADM_PerfilSuperiorCompuerta'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
          ]
        },
        'RANGER XLS DIESEL': {
          model: './models/RANGER_XLS/scene.glb',
          colors: [
            {
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'Azul Relámpago',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
              settings: {
                color: 0x0065D1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'Blanco Ártico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'Gris Magnético',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
              settings: {
                color: 0x808080,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 0.75
              }
						},
            {
							Name: 'NEGRO PERLADO',
							NameAlt: 'Negro Perlado',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
              settings: {
                color: 0x1C1C1C,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 1,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'PLATA METÁLICO',
							NameAlt: 'Plata Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
              settings: {
                color: 0xBBBCC3,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'ROJO RUBI',
							NameAlt: 'Rojo Rubí',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
              settings: {
                color: 0x8A0505,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.3,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.3
              }
						},
					],
          accesories: [
            {
              model: './models/RANGER_XLS/accessories/BDM_BedlinerPerfilSuperior.glb',
              name: 'BDM_BedlinerPerfilSuperior',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/BDM_KitExtensionesRuedaFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedaFenderFlares',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/BDM_ProtectorBumperLucesDRL.glb',
              name: 'BDM_ProtectorBumperLucesDRL',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },

            {
              model: './models/RANGER_XLS/accessories/ADM_BarraK1Cromada.glb',
              name: 'ADM_BarraK1Cromada',
              showroom: 'Barra K1 Cromada',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_BarraK1Cromada.webp',
              hide: ['ADM_BarraK1Negra','ADM_CapotaLonaDCAllBlack', 'ADM_SpoilerCabina'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_BarraK1Negra.glb',
              name: 'ADM_BarraK1Negra',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_BarraK1Negra.webp',
              hide: ['ADM_BarraK1Cromada','ADM_CapotaLonaDCAllBlack', 'ADM_SpoilerCabina'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_BedlinerPerfilSuperior.glb',
              name: 'ADM_BedlinerPerfilSuperior',
              showroom: 'Bedliner con Perfil Superior',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_BedlinerconPerfilSuperior.webp',
              hide: ['ADM_PerfilesSuperioresLaterales','BDM_BedlinerPerfilSuperior','ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_CapotaLonaDCAllBlack.glb',
              name: 'ADM_CapotaLonaDCAllBlack',
              showroom: 'Capota Lona DC All Black',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_CapotaLonaDCAllBlack.webp',
              hide: ['ADM_BarraK1Negra','ADM_BarraK1Cromada','ADM_CapotaLonaBarraFibra'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_EstribosTubularesCromados.glb',
              name: 'ADM_EstribosTubularesCromados',
              showroom: 'Estribos Tubulares Cromados',
              carpaint: false,
              section: 'Estribos',
              Image: './models/RANGER_XLS/thumbs/th_EstribosTubularesCromados.webp',
              hide: ['ADM_EstribosTubularesNegros'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_EstribosTubularesNegros.glb',
              name: 'ADM_EstribosTubularesNegros',
              showroom: 'Estribos Tubulares Negros',
              carpaint: false,
              section: 'Estribos',
              Image: './models/RANGER_XLS/thumbs/th_EstribosTubularesNegros.webp',
              hide: ['ADM_EstribosTubularesCromados'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              showroom: 'Kit Extensiones de Rueda Fender Flares',
              carpaint: false,
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/RANGER_XLS/thumbs/th_KitExtensionesdeRuedaFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedaFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedaFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_MoldurasCapot.glb',
              name: 'ADM_MoldurasCapot',
              showroom: 'Molduras Capó',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_MoldurasCapot.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_PanelesPuerta.glb',
              name: 'ADM_PanelesPuerta',
              showroom: 'Paneles Puerta',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PanelesPuerta.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_PerfilesSuperioresLaterales.glb',
              name: 'ADM_PerfilesSuperioresLaterales',
              showroom: 'Perfiles Superiores Laterales',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_PerfilesSuperioresLaterales.webp',
              hide: ['ADM_BedlinerPerfilSuperior','BDM_BedlinerPerfilSuperior'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_PerfilSuperiorCompuerta.glb',
              name: 'ADM_PerfilSuperiorCompuerta',
              showroom: 'Perfil Superior Compuerta',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLS/thumbs/th_PerfilSuperiorCompuerta.webp',
              hide: ['ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_ProtectorBumperLucesDRL.glb',
              name: 'ADM_ProtectorBumperLucesDRL',
              showroom: 'Protector Bumper Luces DRL',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_ProtectordeBumperconLucesDRL.webp',
              hide: ['BDM_ProtectorBumperLucesDRL'],
              enableOnDisable: ['BDM_ProtectorBumperLucesDRL'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              showroom: 'Spoiler de Cabina',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XLS/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraK1Cromada','ADM_BarraK1Cromada'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              showroom: 'Spoiler Compuerta Trasera',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XLS/thumbs/th_SpoilerCompuertaTrasera.webp',
              hide: ['ADM_PerfilSuperiorCompuerta'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
          ]
        },
        'ESCAPE TITANIUM 4X4 FHEV': {
          model: './models/ESCAPE_TITANIUM/scene.glb',
          colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/AzulMetalico.webp'),
              settings: {
                color: 0x007BC7,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.33,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.04,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeEcoboost/RojoLucido.webp'),
              settings: {
                color: 0xB30002,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
              settings: {
                color: 0x545454,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.67,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/PlataPuro.webp'),
              settings: {
                color: 0x9E9E9E,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.38,
                clearcoat: 0.67,
                reflectivity: 0.8,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.67
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/BlancoPlatino.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x030303,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 1,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 1
              }
						}
					],
          accesories: [
            {
              model: './models/ESCAPE_SE/accessories/BDM_JuegoMoldurasPuerta.glb',
              name: 'BDM_JuegoMoldurasPuerta',
              carpaint: true,
              showroom: 'Juego de molduras de puerta base',
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/BDM_PlacaAntideslizanteTrasera.glb',
              name: 'BDM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera base',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de techo',
              section: 'Barras, Rieles, Parrillas',
              Image: './models/ESCAPE_SEL/thumbs/th_BarrasdeTecho.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos negros',
              section: 'Estribos',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegros.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos negros con bisel cromado',
              section: 'Estribos',
              hide: ['ADM_EstribosNegros'],
              Image: './models/ESCAPE_SEL/thumbs/th_EstribosNegrosconBiselCromado.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoCortinasAire.glb',
              name: 'ADM_JuegoCortinasAire',
              showroom: 'Juego de cortinas de aire',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeCortinasDeAire.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoMoldurasArcoRueda.glb',
              name: 'ADM_JuegoMoldurasArcoRueda',
              showroom: 'Juego de molduras de arco de rueda',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasdeArcodeRueda.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_JuegoMoldurasPuerta.glb',
              name: 'ADM_JuegoMoldurasPuerta',
              showroom: 'Juego de molduras de puerta',
              section: 'Molduras, Paneles, Apliques',
              carpaint: true,
              Image: './models/ESCAPE_SEL/thumbs/th_JuegoDeMoldurasDePuerta.webp',
              hide: ['BDM_JuegoMoldurasPuerta'],
              enableOnDisable: ['BDM_JuegoMoldurasPuerta'],
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_PlacaAntideslizanteDelantera.glb',
              name: 'ADM_PlacaAntideslizanteDelantera',
              showroom: 'Placa antideslizante delantera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteDelantera.webp',
              compatible: [

              ]   
            },
            {
              model: './models/ESCAPE_SE/accessories/ADM_PlacaAntideslizanteTrasera.glb',
              name: 'ADM_PlacaAntideslizanteTrasera',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/ESCAPE_SEL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['BDM_PlacaAntideslizanteTrasera'],
              enableOnDisable: ['BDM_PlacaAntideslizanteTrasera'],
              compatible: [

              ]   
            },
          ]
        },
        'EXPLORER LIMITED': {
          model: './models/EXPLORER_LIMITED/scene.glb',
          colors: [
						/* {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
              settings: {
                color: 0xBD0000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.35,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						}, */
            {
							Name: 'GRIS MAGNÉTICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x3A3D40,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'AZUL OXFORD',
							NameAlt: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerST/AzulOxford.webp'),
              settings: {
                color: 0x193158,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xF2F0ED,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 0.5,
                roughness: 0.9,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xB3B2B2,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.6,
                clearcoat: 0.1,
                reflectivity: 1,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x100F0F,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.1,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            
					],
          accesories: [       
            {
              model: './models/EXPLORER_LIMITED/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de techo',
              carpaint: true,
              section: 'Barras, Rieles, Parrillas',
              Image: './models/EXPLORER_LIMITED/thumbs/th_BarrasdeTecho.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/EXPLORER_LIMITED/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos Negros',
              carpaint: true,
              section: 'Estribos',
              Image: './models/EXPLORER_LIMITED/thumbs/th_EstribosNegros.webp',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
            {
              model: './models/EXPLORER_LIMITED/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos Negros Bisel Cromado',
              carpaint: true,
              section: 'Estribos',
              Image: './models/EXPLORER_LIMITED/thumbs/th_EstribosNegrosconBiselCromado.webp',
              hide: ['ADM_EstribosNegros'],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
            {
              model: './models/EXPLORER_LIMITED/accessories/ADM_TiroArrastre.glb',
              name: 'ADM_TiroArrastre',
              showroom: 'Tiro de Arrastre',
              carpaint: true,
              section: 'Tiro de Arrastre',
              Image: './models/EXPLORER_LIMITED/thumbs/th_TirodeArrastre.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
          ]
        },
        'EXPLORER XLT': {
          model: './models/EXPLORER_XLT/scene.glb',
          colors: [
            {
							Name: 'GRIS MAGNÉTICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x3A3D40,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
						/* {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
              settings: {
                color: 0xBD0000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.35,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						}, */
            {
							Name: 'AZUL OXFORD',
							NameAlt: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerST/AzulOxford.webp'),
              settings: {
                color: 0x193158,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xF2F0ED,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 0.5,
                roughness: 0.9,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xB3B2B2,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.6,
                clearcoat: 0.1,
                reflectivity: 1,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
              settings: {
                color: 0x100F0F,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.1,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            
					],
          accesories: [       
            {
              model: './models/EXPLORER_XLT/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              showroom: 'Barras de techo',
              carpaint: true,
              section: 'Barras, Rieles, Parrillas',
              Image: './models/EXPLORER_XLT/thumbs/th_BarrasdeTecho.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/EXPLORER_XLT/accessories/ADM_EstribosNegros.glb',
              name: 'ADM_EstribosNegros',
              showroom: 'Estribos Negros',
              carpaint: true,
              section: 'Estribos',
              Image: './models/EXPLORER_XLT/thumbs/th_EstribosNegros.webp',
              hide: ['ADM_EstribosNegrosBiselCromado'],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
            {
              model: './models/EXPLORER_XLT/accessories/ADM_EstribosNegrosBiselCromado.glb',
              name: 'ADM_EstribosNegrosBiselCromado',
              showroom: 'Estribos Negros Bisel Cromado',
              carpaint: true,
              section: 'Estribos',
              Image: './models/EXPLORER_XLT/thumbs/th_EstribosNegrosconBiselCromado.webp',
              hide: ['ADM_EstribosNegros'],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
            {
              model: './models/EXPLORER_XLT/accessories/ADM_TiroArrastre.glb',
              name: 'ADM_TiroArrastre',
              showroom: 'Tiro de Arrastre',
              carpaint: true,
              section: 'Tiro de Arrastre',
              Image: './models/EXPLORER_XLT/thumbs/th_TirodeArrastre.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            }, 
          ]
        },
        'RANGER XLT': {
          model: './models/RANGER_XLT/scene.glb',
          colors: [
            {
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'Azul Relámpago',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
              settings: {
                color: 0x0065D1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'Blanco Ártico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'Gris Magnético',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
              settings: {
                color: 0x808080,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 0.75
              }
						},
            {
							Name: 'NEGRO PERLADO',
							NameAlt: 'Negro Perlado',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
              settings: {
                color: 0x000000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.8,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'PLATA METÁLICO',
							NameAlt: 'Plata Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
              settings: {
                color: 0xBBBCC3,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'ROJO RUBI',
							NameAlt: 'Rojo Rubí',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
              settings: {
                color: 0xB40E16,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
					],
          accesories: [
            {
              model: './models/RANGER_XLT/accessories/BDM_BedlinerPerfilSuperior.glb',
              name: 'BDM_BedlinerPerfilSuperior',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/BDM_KitExtensionesRuedaFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedaFenderFlares',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/BDM_ProtectorBumperLucesDRL.glb',
              name: 'BDM_ProtectorBumperLucesDRL',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_BedlinerSinPerfilSuperiors.glb',
              name: 'ADM_BedlinerSinPerfilSuperiors',
              showroom: 'Bedliner Sin Perfil Superior',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLT/thumbs/th_BedlinerconPerfilSuperior.webp',
              hide: ['ADM_PerfilesSuperioresLaterales','BDM_BedlinerPerfilSuperior','ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_CapotaLonaFlex.glb',
              name: 'ADM_CapotaLonaFlex',
              showroom: 'Capota Lona Flex',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLT/thumbs/th_CapotaLonaDCAllBlack.webp',
              hide: ['ADM_BarraK1Negra','ADM_BarraK1Cromada','ADM_CapotaLonaBarraFibra'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              showroom: 'Kit Extensiones de Rueda Fender Flares',
              carpaint: false,
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/RANGER_XLT/thumbs/th_KitExtensionesdeRuedaFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedaFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedaFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_MoldurasCapot.glb',
              name: 'ADM_MoldurasCapot',
              showroom: 'Molduras Capó',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_MoldurasCapot.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_PanelesPuerta.glb',
              name: 'ADM_PanelesPuerta',
              showroom: 'Paneles Puerta',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_PanelesPuerta.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_PerfilesSuperioresLaterales.glb',
              name: 'ADM_PerfilesSuperioresLaterales',
              showroom: 'Perfiles Superiores Laterales',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLT/thumbs/th_PerfilesSuperioresLaterales.webp',
              hide: ['ADM_BedlinerPerfilSuperior','BDM_BedlinerPerfilSuperior'],
              enableOnDisable: ['BDM_BedlinerPerfilSuperior'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_PerfilSuperiorCompuerta.glb',
              name: 'ADM_PerfilSuperiorCompuerta',
              showroom: 'Perfil Superior Compuerta',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_XLT/thumbs/th_PerfilSuperiorCompuerta.webp',
              hide: ['ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_ProtectorBumperLucesDRL.glb',
              name: 'ADM_ProtectorBumperLucesDRL',
              showroom: 'Protector Bumper Luces DRL',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLT/thumbs/th_ProtectordeBumperconLucesDRL.webp',
              hide: ['BDM_ProtectorBumperLucesDRL'],
              enableOnDisable: ['BDM_ProtectorBumperLucesDRL'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              showroom: 'Spoiler de Cabina',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XLT/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraK1Cromada','ADM_BarraK1Cromada'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLT/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              showroom: 'Spoiler Compuerta Trasera',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XLT/thumbs/th_SpoilerCompuertaTrasera.webp',
              hide: ['ADM_PerfilSuperiorCompuerta'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
          ]
        },
        'RANGER LIMITED': {
          model: './models/RANGER_LIMITED/scene.glb',
          colors: [
            {
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'Azul Relámpago',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
              settings: {
                color: 0x0065D1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'Blanco Ártico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'Gris Magnético',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
              settings: {
                color: 0x808080,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 0.75
              }
						},
            {
							Name: 'NEGRO PERLADO',
							NameAlt: 'Negro Perlado',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
              settings: {
                color: 0x1C1C1C,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.4,
                reflectivity: 1,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'PLATA METÁLICO',
							NameAlt: 'Plata Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
              settings: {
                color: 0xBBBCC3,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'ROJO RUBI',
							NameAlt: 'Rojo Rubí',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
              settings: {
                color: 0x8A0505,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.3,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.3
              }
						},
					],
          accesories: [
            {
              model: './models/RANGER_LIMITED/accessories/BDM_SpoilerCabina.glb',
              name: 'BDM_SpoilerCabina',
              showroom: 'Spoiler Cabina',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['ADM_SpoilerCabina.glb'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/BDM_KitExtensionesRuedaFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedaFenderFlares',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/BDM_ProtectorBumperLucesDRL.glb',
              name: 'BDM_ProtectorBumperLucesDRL',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_CapotaLonaBarraFibra.glb',
              name: 'ADM_CapotaLonaBarraFibra',
              showroom: 'Capota Lona Barra Fibra',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_LIMITED/thumbs/th_CapotaLonaDCAllBlack.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              showroom: 'Kit Extensiones de Rueda Fender Flares',
              carpaint: false,
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/RANGER_LIMITED/thumbs/th_KitExtensionesdeRuedaFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedaFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedaFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_MoldurasCapot.glb',
              name: 'ADM_MoldurasCapot',
              showroom: 'Molduras Capó',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_MoldurasCapot.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_PanelesPuerta.glb',
              name: 'ADM_PanelesPuerta',
              showroom: 'Paneles Puerta',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_PanelesPuerta.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_PerfilSuperiorCompuerta.glb',
              name: 'ADM_PerfilSuperiorCompuerta',
              showroom: 'Perfil Superior Compuerta',
              carpaint: false,
              section: 'Accesorios de Platón',
              Image: './models/RANGER_LIMITED/thumbs/th_PerfilSuperiorCompuerta.webp',
              hide: ['ADM_SpoilerCompuertaTrasera'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_ProtectorBumperLucesDRL.glb',
              name: 'ADM_ProtectorBumperLucesDRL',
              showroom: 'Protector Bumper Luces DRL',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_LIMITED/thumbs/th_ProtectordeBumperconLucesDRL.webp',
              hide: ['BDM_ProtectorBumperLucesDRL'],
              enableOnDisable: ['BDM_ProtectorBumperLucesDRL'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              showroom: 'Spoiler de Cabina',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_LIMITED/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraK1Cromada','ADM_BarraK1Cromada','BDM_SpoilerCabina','ADM_CapotaLonaBarraFibra'],
              enableOnDisable: ['BDM_SpoilerCabina'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_LIMITED/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              showroom: 'Spoiler Compuerta Trasera',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_LIMITED/thumbs/th_SpoilerCompuertaTrasera.webp',
              hide: ['ADM_PerfilSuperiorCompuerta'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
          ]
        },
        'BRONCO SPORT WILDTRAK': {
          model: './models/BRONCO_WILDTRAK/scene.glb',
          colors: [
            {
							Name: 'NARANJA METÁLICO',
							NameAlt: 'NARANJA METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/BroncoWT/NaranjaMetalico.webp'),
              settings: {
                color: 0xFFA500,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0
              }
						},
						{
							Name: 'ROJO SAFARI',
							NameAlt: 'ROJO SAFARI',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/BroncoWT/RojoMetalico.webp'),
              settings: {
                color: 0xDB0000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/BroncoWT/GrisCarbon.webp'),
              settings: {
                color: 0x525456,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.5,
                clearcoat: 0.3,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0
              }
						},
						{
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/BroncoWT/PlataPuro.webp'),
              settings: {
                color: 0x737373,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0
              }
						},
					],
          accesories: [
            {
              model: './models/BRONCO_WILDTRAK/accessories/BDM_KitExtensionesRuedasFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedasFenderFlares',
              carpaint: true,
              showroom: 'Difusor de Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/BDM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'BDM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: true,
              showroom: 'Difusor de Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },

            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              carpaint: false,
              showroom: 'Barras de techo',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_BarrasdeTecho.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              carpaint: false,
              showroom: 'Kit Extensiones de Ruedas Fender Flares',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_KitExtensionesdeRuedasFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedasFenderFlares','ADM_KitExtensionesRuedasFenderFlaresFord'],
              enableOnDisable: ['BDM_KitExtensionesRuedasFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: false,
              showroom: 'Kit Extensiones de Ruedas Fender Flares Ford',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ KitExtensionesdeRuedasFenderFlares_2.webp',
              hide: ['BDM_KitExtensionesRuedasFenderFlaresFord','ADM_KitExtensionesRuedasFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedasFenderFlaresFord'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_MoldurasPuertas.glb',
              name: 'ADM_MoldurasPuertas',
              carpaint: false,
              showroom: 'Molduras de Puertas',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_MoldurasdePuertas.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_ProtectorBumperTrasero.glb',
              name: 'ADM_ProtectorBumperTrasero',
              carpaint: false,
              showroom: 'Protector de Bumper Trasero',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ProtectordeBumperTrasero.webp',
              hide: [],
              compatible: [
              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_ProtectorCapo.glb',
              name: 'ADM_ProtectorCapo',
              carpaint: false,
              showroom: 'Protector de Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ProtectordeCapo.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_SalpicaderasLlantasDelanteras.glb',
              name: 'ADM_SalpicaderasLlantasDelanteras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Delanteras',
              section: 'Salpicaderas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SalpicaderasLlantasDelanteras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_SalpicaderasLlantasTraseras.glb',
              name: 'ADM_SalpicaderasLlantasTraseras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Traseras',
              section: 'Salpicaderas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SalpicaderasLlantasTraseras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_SpoilerTecho.glb',
              name: 'ADM_SpoilerTecho',
              carpaint: false,
              showroom: 'Spoiler de Techo',
              section: 'Spoilers',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SpoilerdeTecho.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_WILDTRAK/accessories/ADM_TomaAireCapo.glb',
              name: 'ADM_TomaAireCapo',
              carpaint: false,
              showroom: 'Toma de Aire Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_TomadeAireCapo.webp',
              hide: [],
              compatible: [

              ]   
            },
          ]
        },
        'F-150 LARIAT SPORT':{
          model: './models/F150_LARIAT/scene.glb',
          colors: [
						/* {
							Name: 'AZUL GALACTICO',
							NameAlt: 'Azul Galáctico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/AzulGalactico.webp'),
              settings: {
                color: 0x003D9E,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						}, */
            {
							Name: 'BLANCO OXFORD',
							NameAlt: 'Blanco Oxford',
							Hexa: '#D8DDE9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/BlancoOxford.webp'),
              settings: {
                color: 0xFCFCFC,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.6,
                clearcoat: 0.3,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'ROJO METÁLICO',
							NameAlt: 'Rojo Metálico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/RojoMetalico.webp'),
              settings: {
                color: 0xA30000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'Gris Carbón',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/GrisCarbon.webp'),
              settings: {
                color: 0x525456,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.35,
                reflectivity: 0,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'Plata Puro',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/PlataPuro.webp'),
              settings: {
                color: 0xD1D1D1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.7,
                clearcoat: 0.25,
                reflectivity: 0,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.35
              }
						},
            {
							Name: 'NEGRO ÁGATA',
							NameAlt: 'Negro Ágata',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/NegroAgata.webp'),
              settings: {
                color: 0x0F0F0F,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.5
              }
						}
					],
          accesories: [
            {
              model: './models/F150_RAPTOR/accessories/ADM_BarraAntivuelcoNegraMate.glb',
              name: 'ADM_BarraAntivuelcoNegraMate',
              carpaint: false,
              showroom: 'Barra Antivuelco Negro Mate',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/F150_RAPTOR/thumbs/th_BarraAntivuelcoNegraMate.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_SpoilerCabina'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CajaAlmacenamientoIzquierdo.glb',
              name: 'ADM_CajaAlmacenamientoIzquierdo',
              carpaint: false,
              showroom: 'Caja de Almacenamiento Izquierdo',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CajadeAlmacenamientoLadoIzquierdo.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlatonSuave.glb',
              name: 'ADM_CubiertaPlatonSuave',
              carpaint: false,
              showroom: 'Cubierta de Platón Suave',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlatonSuave5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_MallaCarga','ADM_CajaAlmacenamientoIzquierdo'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlegableCubreplaton.glb',
              name: 'ADM_CubiertaPlegableCubreplaton',
              carpaint: false,
              showroom: 'Cubierta Plegable Cubreplatón 5.5',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlegableCubreplaton5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_CubiertaPlegablePlaton.glb',
              name: 'ADM_CubiertaPlegablePlaton',
              carpaint: false,
              showroom: 'Cubierta Plegable de Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_CubiertaPlegablePlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_DivisorPlaton.glb',
              name: 'ADM_DivisorPlaton',
              carpaint: false,
              showroom: 'Divisor Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_RAPTOR/thumbs/th_DivisorPlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_MallaCarga'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_MallaCarga.glb',
              name: 'ADM_MallaCarga',
              carpaint: false,
              showroom: 'Malla de Carga',
              section: 'Organizadores de Carga',
              Image: './models/F150_RAPTOR/thumbs/th_MalladeCarga.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_MolduraPuertas.glb',
              name: 'ADM_MolduraPuertas',
              carpaint: false,
              showroom: 'Moldura de Puertas',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_RAPTOR/thumbs/th_MolduradePuertas.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_SalpicaderasLlantasDelanteras.glb',
              name: 'ADM_SalpicaderasLlantasDelanteras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Delanteras',
              section: 'Salpicaderas',
              Image: './models/F150_LARIAT/thumbs/th_SalpicaderasLlantasDelanteras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SalpicaderasLlantasTraseras.glb',
              name: 'ADM_SalpicaderasLlantasTraseras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas traseras',
              section: 'Salpicaderas',
              Image: './models/F150_RAPTOR/thumbs/th_SalpicaderasLlantasTraseras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              carpaint: false,
              showroom: 'Spoiler de Cabina',
              section: 'Spoilers',
              Image: './models/F150_RAPTOR/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraAntivuelcoNegraMate'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_RAPTOR/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              carpaint: false,
              showroom: 'Spoiler de Compuerta Trasera',
              section: 'Spoilers',
              Image: './models/F150_RAPTOR/thumbs/th_SpoilerdeCompuertaTrasera.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              carpaint: false,
              showroom: 'Kit Extensiones Ruedas Fender Flares',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/F150_LARIAT/thumbs/th_KitExtensionesdeRuedasFenderFlares.webp',
              hide: ['ADM_KitExtensionesRuedasFenderFlaresFord'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: false,
              showroom: 'Kit Extensiones Ruedas Fender Flares Ford',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/F150_LARIAT/thumbs/th_KitExtensionesdeRuedasFenderFlares_2.webp',
              hide: ['ADM_KitExtensionesRuedasFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_MolduraCompuertaTrasera.glb',
              name: 'ADM_MolduraCompuertaTrasera',
              carpaint: false,
              showroom: 'Moldura Compuerta Trasera',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_LARIAT/thumbs/th_MolduraCompuertaTrasera.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_PuntaEscapeCromada275.glb',
              name: 'ADM_PuntaEscapeCromada2',
              carpaint: false,
              showroom: 'Punta Escape Cromada 2.75',
              section: 'Punta de Escape',
              Image: './models/F150_LARIAT/thumbs/th_PuntadeEscapeCromada2_75.webp',
              hide: ['ADM_PuntaEscapeCromada3'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_PuntaEscapeCromada3.glb',
              name: 'ADM_PuntaEscapeCromada3',
              carpaint: false,
              showroom: 'Punta Escape Cromada 3',
              section: 'Punta de Escape',
              Image: './models/F150_LARIAT/thumbs/th_PuntadeEscapeCromada3.webp',
              hide: ['ADM_PuntaEscapeCromada2'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_LARIAT/accessories/ADM_TomaAireCapo.glb',
              name: 'ADM_TomaAireCapo',
              carpaint: false,
              showroom: 'Toma Aire Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_LARIAT/thumbs/th_TomadeAireCapo.webp',
              hide: ['ADM_PuntaEscapeCromada2'],
              compatible: [

              ]   
            },
          ]
        },
        /*'RANGER LIMITED BLACK EDITION':{
          model: './models/RANGER_LIMITED_BLACK/scene.glb',
          colors: [
					],
          accesories: [
          ]
        },*/
        /* 'EDGE SEL': {
          model: './models/EDGE_SEL/scene.glb',
          colors: [
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x545256,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'BLANCO PLATINO',
							NameAlt: 'BLANCO PLATINO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xFFFFFF,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.4
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xC8C8D0,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 0.4,
                reflectivity: 0.8,
                clearcoatRoughness: 0.1,
                clearcoatIntensity: 0.4
              }
						},
            
					],
          accesories: [    
            {
              model: './models/EDGE_SEL/accessories/BDM_SalpicaderasDelanteras.glb',
              name: 'BDM_BedlinerPerfilSuperior',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/EDGE_SEL/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },        
          ]
        }, */
        'BRONCO SPORT BIG BEND': {
          model: './models/BRONCO_BIGBEND/scene.glb',
          colors: [
            {
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/BroncoBB/AzulMetalico.webp'),
              settings: {
                color: 0x132B3A,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                reflectivity: 0.5,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.4
              }
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/BroncoWT/RojoMetalico.webp'),
              settings: {
                color: 0xFE0000,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 1,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/BroncoWT/GrisCarbon.webp'),
              settings: {
                color: 0x525456,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.35,
                reflectivity: 0,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.35
              }
						},
						{
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/BroncoWT/PlataPuro.webp'),
              settings:{
                color: 0x737373,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.35,
                reflectivity: 0,
                clearcoatRoughness: 0.08,
                clearcoatIntensity: 0.35
              }
						},
					],
          accesories: [
            {
              model: './models/BRONCO_BIGBEND/accessories/BDM_KitExtensionesRuedasFenderFlares.glb',
              name: 'BDM_KitExtensionesRuedasFenderFlares',
              carpaint: true,
              showroom: 'Difusor de Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/BDM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'BDM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: true,
              showroom: 'Difusor de Balance Trasero',
              section: 'Faldones y Extensiones de Ruedas',
              Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
              hide: ['ADM_DifusorBalanceTrasero'],
              compatible: [

              ]   
            },

            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_BarrasTecho.glb',
              name: 'ADM_BarrasTecho',
              carpaint: false,
              showroom: 'Barras de techo',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_BarrasdeTecho.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              carpaint: false,
              showroom: 'Kit Extensiones de Ruedas Fender Flares',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_KitExtensionesdeRuedasFenderFlares.webp',
              hide: ['BDM_KitExtensionesRuedasFenderFlares'],
              enableOnDisable: ['BDM_KitExtensionesRuedasFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: false,
              showroom: 'Kit Extensiones de Ruedas Fender Flares Ford',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ KitExtensionesdeRuedasFenderFlares_2.webp',
              hide: ['BDM_KitExtensionesRuedasFenderFlaresFord'],
              enableOnDisable: ['BDM_KitExtensionesRuedasFenderFlaresFord'],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_MoldurasPuertas.glb',
              name: 'ADM_MoldurasPuertas',
              carpaint: false,
              showroom: 'Molduras de Puertas',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_MoldurasdePuertas.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_ProtectorBumperTrasero.glb',
              name: 'ADM_ProtectorBumperTrasero',
              carpaint: false,
              showroom: 'Protector de Bumper Trasero',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ProtectordeBumperTrasero.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_ProtectorCapo.glb',
              name: 'ADM_ProtectorCapo',
              carpaint: false,
              showroom: 'Protector de Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_ProtectordeCapo.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_SalpicaderasLlantasDelanteras.glb',
              name: 'ADM_SalpicaderasLlantasDelanteras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Delanteras',
              section: 'Salpicaderas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SalpicaderasLlantasDelanteras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_SalpicaderasLlantasTraseras.glb',
              name: 'ADM_SalpicaderasLlantasTraseras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Traseras',
              section: 'Salpicaderas',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SalpicaderasLlantasTraseras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_SpoilerTecho.glb',
              name: 'ADM_SpoilerTecho',
              carpaint: false,
              showroom: 'Spoiler de Techo',
              section: 'Spoilers',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_SpoilerdeTecho.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/BRONCO_BIGBEND/accessories/ADM_TomaAireCapo.glb',
              name: 'ADM_TomaAireCapo',
              carpaint: false,
              showroom: 'Toma de Aire Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/BRONCO_WILDTRAK/thumbs/th_TomadeAireCapo.webp',
              hide: [],
              compatible: [

              ]   
            },
          ]
        },
        'RANGER XL CHASIS': {
          model: './models/RANGER_XLS_CHASIS/scene.glb',
          colors: [
            {
							Name: 'BLANCO ARTICO',
							NameAlt: 'Blanco Ártico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
              settings: {
                color: 0xFEFEFE,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.75,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 1
              }
						},
            {
							Name: 'GRIS MAGNETICO',
							NameAlt: 'Gris Magnético',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
              settings: {
                color: 0x808080,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.3,
                clearcoat: 0.4,
                clearcoatRoughness: 0,
                clearcoatIntensity: 0.75
              }
						}
					],
          accesories: [
            {
              model: './models/RANGER_XLS_CHASIS/accessories/BDM_ExtensionesRueda2Chasis.glb',
              name: 'BDM_ExtensionesRueda2Chasis',
              showroom: 'Placa antideslizante trasera',
              carpaint: true,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: ['ADM_ExtensionesRueda2Chasis'],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS_CHASIS/accessories/BDM_ProtectorBumperLucesDRL.glb',
              name: 'BDM_ProtectorBumperLucesDRL',
              showroom: 'Placa antideslizante trasera',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_PlacaAntideslizanteTrasera.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS_CHASIS/accessories/ADM_ExtensionesRueda2Chasis.glb',
              name: 'ADM_ExtensionesRueda2Chasis',
              showroom: 'Kit Extensiones de Rueda Fender Flares',
              carpaint: false,
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/RANGER_XLS/thumbs/th_KitExtensionesdeRuedaFenderFlares.webp',
              hide: ['BDM_ExtensionesRueda2Chasis'],
              enableOnDisable: ['BDM_ExtensionesRueda2Chasis'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS_CHASIS/accessories/ADM_MoldurasCapo.glb',
              name: 'ADM_MoldurasCapot',
              showroom: 'Molduras Capó',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_MoldurasCapot.webp',
              hide: [],
              enableOnDisable: [],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS_CHASIS/accessories/ADM_ProtectorBumperLucesDRL.glb',
              name: 'ADM_ProtectorBumperLucesDRL',
              showroom: 'Protector Bumper Luces DRL',
              carpaint: false,
              section: 'Molduras, Paneles, Apliques',
              Image: './models/RANGER_XLS/thumbs/th_ProtectordeBumperconLucesDRL.webp',
              hide: ['BDM_ProtectorBumperLucesDRL'],
              enableOnDisable: ['BDM_ProtectorBumperLucesDRL'],
              compatible: [

              ]   
            },
            {
              model: './models/RANGER_XLS_CHASIS/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              showroom: 'Spoiler de Cabina',
              carpaint: false,
              section: 'Spoilers',
              Image: './models/RANGER_XLS/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraK1Cromada','ADM_BarraK1Cromada'],
              enableOnDisable: [],
              compatible: [

              ]   
            }
          ]
        },
        /*'F-150 XLT FHEV':{
          model: './models/F150_XLT/scene.glb',
          colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#A30000',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
              settings: {
                color: 0xA30000,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
              settings: {
                color: 0x5A5C5E,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.2
              }
						},
            {
							Name: 'BLANCO OXFORD',
							NameAlt: 'BLANCO OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
              settings: {
                color: 0xFCFCFC,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.6,
                clearcoat: 0.3,
                reflectivity: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0x959CB1,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.4,
                clearcoat: 1,
                reflectivity: 1,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 1
              }
						},
					],
          accesories: [
          ]
        },*/
        'F-150 PLATINUM FHEV':{
          model: './models/F150_PLATINUM/scene.glb',
          colors: [
						{
							Name: 'AZUL GALACTICO',
							NameAlt: 'Azul Galáctico',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/AzulGalactico.webp'),
              settings: {
                color: 0x001032,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'GRIS CARBÓN',
							NameAlt: 'Gris Carbón',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/GrisCarbon.webp'),
              settings: {
                color: 0x5A5C5E,
                emissive: 0x000000,
                emissiveIntesity: 0,
                metalness: 1,
                roughness: 0.25,
                clearcoat: 0.2,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.2
              },
						},
            {
							Name: 'PLATA PURO',
							NameAlt: 'PLATA PURO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
              settings: {
                color: 0xC7C7C7,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
            {
							Name: 'NEGRO AGATA',
							NameAlt: 'Negro Ágata',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/NegroAgata.webp'),
              settings: {
                color: 0x0F0F0F,
                emissive: 0x000000,
                emissiveIntesity: 1,
                metalness: 1,
                roughness: 0.45,
                clearcoat: 0.3,
                reflectivity: 0,
                clearcoatRoughness: 0.05,
                clearcoatIntensity: 0.3
              }
						},
					],
          accesories: [
            {
              model: './models/F150_PLATINUM/accessories/BDM_LogosBase.glb',
              name: 'BDM_LogosBase',
              carpaint: false,
              showroom: 'Barra Antivuelco Negro Mate',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/F150_PLATINUM/thumbs/th_BarraAntivuelcoNegraMate.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_SpoilerCabina'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/BDM_MolduraCompuertaTrasera.glb',
              name: 'BDM_MolduraCompuertaTrasera',
              carpaint: false,
              showroom: 'Moldura Compuerta Trasera',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_PLATINUM/thumbs/th_BarraAntivuelcoNegraMate.webp',
              hide: ['ADM_BarraAntivuelcoNegraMate'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_BarraAntivuelcoNegraMate.glb',
              name: 'ADM_BarraAntivuelcoNegraMate',
              carpaint: false,
              showroom: 'Barra Antivuelco Negro Mate',
              section: 'Barras, Rieles, Parrilas de Techo',
              Image: './models/F150_PLATINUM/thumbs/th_BarraAntivuelcoNegraMate.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_SpoilerCabina'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_CajaAlmacenamientoIzquierdo.glb',
              name: 'ADM_CajaAlmacenamientoIzquierdo',
              carpaint: false,
              showroom: 'Caja de Almacenamiento Izquierdo',
              section: 'Accesorios de Platón',
              Image: './models/F150_PLATINUM/thumbs/th_CajadeAlmacenamientoLadoIzquierdo.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_CubiertaPlatonSuave.glb',
              name: 'ADM_CubiertaPlatonSuave',
              carpaint: false,
              showroom: 'Cubierta de Platón Suave',
              section: 'Accesorios de Platón',
              Image: './models/F150_PLATINUM/thumbs/th_CubiertaPlatonSuave5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_MallaCarga','ADM_CajaAlmacenamientoIzquierdo'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_CubiertaPlegableCubreplaton.glb',
              name: 'ADM_CubiertaPlegableCubreplaton',
              carpaint: false,
              showroom: 'Cubierta Plegable Cubreplatón 5.5',
              section: 'Accesorios de Platón',
              Image: './models/F150_PLATINUM/thumbs/th_CubiertaPlegableCubreplaton5_5.webp',
              hide: ['ADM_CubiertaPlegablePlaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_CubiertaPlegablePlaton.glb',
              name: 'ADM_CubiertaPlegablePlaton',
              carpaint: false,
              showroom: 'Cubierta Plegable de Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_PLATINUM/thumbs/th_CubiertaPlegablePlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_DivisorPlaton','ADM_CubiertaPlatonSuave'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_DivisorPlaton.glb',
              name: 'ADM_DivisorPlaton',
              carpaint: false,
              showroom: 'Divisor Platón',
              section: 'Accesorios de Platón',
              Image: './models/F150_PLATINUM/thumbs/th_DivisorPlaton.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_MallaCarga'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_MallaCarga.glb',
              name: 'ADM_MallaCarga',
              carpaint: false,
              showroom: 'Malla de Carga',
              section: 'Organizadores de Carga',
              Image: './models/F150_PLATINUM/thumbs/th_MalladeCarga.webp',
              hide: ['ADM_CubiertaPlegableCubreplaton','ADM_CubiertaPlegablePlaton','ADM_CubiertaPlatonSuave','ADM_DivisorPlaton'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_MolduraPuertas.glb',
              name: 'ADM_MolduraPuertas',
              carpaint: false,
              showroom: 'Moldura de Puertas',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_PLATINUM/thumbs/th_MolduradePuertas.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_SalpicaderasLlantasDelanteras.glb',
              name: 'ADM_SalpicaderasLlantasDelanteras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas Delanteras',
              section: 'Salpicaderas',
              Image: './models/F150_PLATINUM/thumbs/th_SalpicaderasLlantasDelanteras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_SalpicaderasLlantasTraseras.glb',
              name: 'ADM_SalpicaderasLlantasTraseras',
              carpaint: false,
              showroom: 'Salpicaderas Llantas traseras',
              section: 'Salpicaderas',
              Image: './models/F150_PLATINUM/thumbs/th_SalpicaderasLlantasTraseras.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_SpoilerCabina.glb',
              name: 'ADM_SpoilerCabina',
              carpaint: false,
              showroom: 'Spoiler de Cabina',
              section: 'Spoilers',
              Image: './models/F150_PLATINUM/thumbs/th_SpoilerdeCabina.webp',
              hide: ['ADM_BarraAntivuelcoNegraMate'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_SpoilerCompuertaTrasera.glb',
              name: 'ADM_SpoilerCompuertaTrasera',
              carpaint: false,
              showroom: 'Spoiler de Compuerta Trasera',
              section: 'Spoilers',
              Image: './models/F150_PLATINUM/thumbs/th_SpoilerdeCompuertaTrasera.webp',
              hide: [],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_KitExtensionesRuedasFenderFlares.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlares',
              carpaint: false,
              showroom: 'Kit Extensiones Ruedas Fender Flares',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/F150_PLATINUM/thumbs/th_KitExtensionesdeRuedasFenderFlares.webp',
              hide: ['ADM_KitExtensionesRuedasFenderFlaresFord'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_KitExtensionesRuedasFenderFlaresFord.glb',
              name: 'ADM_KitExtensionesRuedasFenderFlaresFord',
              carpaint: false,
              showroom: 'Kit Extensiones Ruedas Fender Flares Ford',
              section: 'Faldones y Extensiones de Ruedas',
              Image: './models/F150_PLATINUM/thumbs/th_KitExtensionesdeRuedasFenderFlares_2.webp',
              hide: ['ADM_KitExtensionesRuedasFenderFlares'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_MolduraCompuertaTrasera.glb',
              name: 'ADM_MolduraCompuertaTrasera',
              carpaint: false,
              showroom: 'Moldura Compuerta Trasera',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_PLATINUM/thumbs/th_MolduraCompuertaTrasera.webp',
              hide: ['BDM_MolduraCompuertaTrasera'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_PuntaEscapeCromada275.glb',
              name: 'ADM_PuntaEscapeCromada2',
              carpaint: false,
              showroom: 'Punta Escape Cromada 2.75',
              section: 'Punta de Escape',
              Image: './models/F150_PLATINUM/thumbs/th_PuntadeEscapeCromada2_75.webp',
              hide: ['ADM_PuntaEscapeCromada3'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_PuntaEscapeCromada3.glb',
              name: 'ADM_PuntaEscapeCromada3',
              carpaint: false,
              showroom: 'Punta Escape Cromada 3',
              section: 'Punta de Escape',
              Image: './models/F150_PLATINUM/thumbs/th_PuntadeEscapeCromada3.webp',
              hide: ['ADM_PuntaEscapeCromada2'],
              compatible: [

              ]   
            },
            {
              model: './models/F150_PLATINUM/accessories/ADM_TomaAireCapo.glb',
              name: 'ADM_TomaAireCapo',
              carpaint: false,
              showroom: 'Toma Aire Capó',
              section: 'Molduras, Paneles, Apliques',
              Image: './models/F150_PLATINUM/thumbs/th_TomadeAireCapo.webp',
              hide: ['ADM_PuntaEscapeCromada2'],
              compatible: [

              ]   
            },
          ]
        },
      }
    ]
  }
}